var _linearGradient, _linearGradient2, _linearGradient3, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1537d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0522a5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea3058"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce173e"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fecb2f"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    height: 11.428571,
    rx: 1,
    width: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#a)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.619048 0h8.380952v11.428571h-8.380952z",
    fill: "url(#b)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.333333 0h5.333333v11.428571h-5.333333z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.23809524 4.95238095h.76190476v.38095238h-.76190476z",
    fill: "#ffedb1",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d32e28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.36382971 6.06439672c.0187458.22494958.22240869.41179376.44755376.41179376h.37723306c.22451718 0 .42892976-.1883056.44755376-.41179376l.09266796-1.11201577h-1.45767652zm-.47523358-1.11552893c-.01737116-.20845392.13292966-.37743922.34598595-.37743922h1.53083582c.20845395 0 .36374065.16438293.34598599.37743922l-.09559711 1.14716531c-.0350291.42034931-.40395908.76110976-.82719025.76110976h-.37723306c-.42181546 0-.79186984-.33726502-.82719024-.76110976z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.23809524 5.33333333h1.52380952v.38095238h-.38095238-.76190476-.38095238z",
    mask: "url(#d)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/AD.fe041136a41b03b350af41cb974a7efe.svg";
export { ForwardRef as ReactComponent };